const REDACTED = '***';

const PII_KEYS = new Set([
	'recordsubject',
	'displayname',
	'firstname',
	'lastname',
	'middlename',
	'fullname',
	'email',
	'emails',
	'socialsecuritynumber',
	'ssn',
	'insured',
	'insuredemail',
	'insuredphone',
	'assignedto',
	'plaintiffname',
	'dateofbirth',
	'dateofdeath',
	'phonenumber',
	'phone',
	'names',
	'accesstoken',
	'refreshtoken',
	'password',
	'token'
]);

export function redactPii(value: unknown): unknown {
	if (Array.isArray(value)) {
		return value.map(redactPii);
	}
	if (value && typeof value === 'object') {
		return Object.fromEntries(
			Object.entries(value as Record<string, unknown>).map(([key, nested]) => [key, PII_KEYS.has(key.toLowerCase()) ? REDACTED : redactPii(nested)])
		);
	}
	return value;
}

export function redactNetworkBody(body: unknown): string | null {
	if (body == null) {
		return null;
	}
	if (typeof body === 'object') {
		return JSON.stringify(redactPii(body));
	}
	if (typeof body === 'string') {
		const trimmed = body.trim();
		if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
			try {
				return JSON.stringify(redactPii(JSON.parse(trimmed)));
			} catch {
				return body;
			}
		}
		return body;
	}
	return String(body);
}
